// extracted by mini-css-extract-plugin
module.exports = {"wide":"measures_wide__oBr4w","medium":"measures_medium__oUoaZ","narrow":"measures_narrow__sVaem","ultraNarrow":"measures_ultraNarrow___P4tT","article":"measures_article__MSSRi"};